/*************************************************/
/* LOGO SLIDER                                   */
/*************************************************/
import Swiper from "swiper";
import { Autoplay } from "swiper/modules";

export function logoSlider() {
    document.querySelectorAll(".logo-slider__swiper").forEach(el => {
        new Swiper(el, {
            modules: [Autoplay],
            loop: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            slidesPerView: 2,
            slidesPerGroup: 1,
            spaceBetween: 20,
            breakpoints: {
                992: {
                    slidesPerView: 4,
                    spaceBetween: 40,
                },
            },
        });
    });
}
